import instance from './instance';

export const fetchDefaultTemplates = () => instance.get('/update_ai_settings/default_templates');

export const createUpdateAiSetting = data => instance.post('/update_ai_settings', data);

export const fetchUpdateAiSetting = ({ slug }) => instance.get(`/update_ai_settings/${slug}`);

export const updateUpdateAiSetting = ({ slug, data }) => instance.patch(`/update_ai_settings/${slug}`, data);

export const createUpdateAiTemplateSection = ({ slug, data }) =>
  instance.post(`/update_ai_settings/${slug}/update_ai_template_sections`, data);

export const updateUpdateAiTemplateSection = ({ slug, templateSectionSlug, data }) =>
  instance.patch(`/update_ai_settings/${slug}/update_ai_template_sections/${templateSectionSlug}`, data);

export const removeUpdateAiTemplateSection = ({ slug, templateSectionSlug }) =>
  instance.delete(`/update_ai_settings/${slug}/update_ai_template_sections/${templateSectionSlug}`);

// export const createUpdateAiReportSections = ({ slug, reportSlug, data }) =>
//   instance.post(`/update_ai_reports/${reportSlug}/generate_sections`, data);

// export const updateUpdateAiReport = ({ slug, reportSlug, data }) =>
//   instance.patch(`/update_ai_settings/${slug}/update_ai_reports/${reportSlug}`, data);
